import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Initialize state from localStorage
  const [authToken, setAuthTokenState] = useState(() => localStorage.getItem('authToken') || null);
  const [selectedShopCode, setSelectedShopCodeState] = useState(() => localStorage.getItem('selectedShopCode') || '');
  const [shopName, setShopNameState] = useState(() => localStorage.getItem('shopName') || '');

  // Update localStorage whenever authToken changes
  useEffect(() => {
    if (authToken) {
      localStorage.setItem('authToken', authToken);
    } else {
      localStorage.removeItem('authToken');
    }
  }, [authToken]);

  // Update localStorage whenever selectedShopCode changes
  useEffect(() => {
    if (selectedShopCode) {
      localStorage.setItem('selectedShopCode', selectedShopCode);
    } else {
      localStorage.removeItem('selectedShopCode');
    }
  }, [selectedShopCode]);

  // Update localStorage whenever shopName changes
  useEffect(() => {
    if (shopName) {
      localStorage.setItem('shopName', shopName);
    } else {
      localStorage.removeItem('shopName');
    }
  }, [shopName]);

  // Wrapper functions to update both state and localStorage
  const setAuthToken = (token) => {
    setAuthTokenState(token);
  };

  const setSelectedShopCode = (shopCode) => {
    setSelectedShopCodeState(shopCode);
  };

  const setShopName = (name) => {
    setShopNameState(name);
  };

  const value = {
    authToken,
    setAuthToken,
    selectedShopCode,
    setSelectedShopCode,
    shopName,
    setShopName,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { AuthContext, useAuth };